import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { FormControl, FormRecord, ReactiveFormsModule } from '@angular/forms';
import type { MatChipListboxChange } from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import type { CodeListItem } from '@models/codelist';

@Component({
  selector: 'app-localized-item-editor',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatChipsModule, MatFormFieldModule, MatInputModule],
  templateUrl: './localized-item-editor.component.html',
})
export class LocalizedItemEditorComponent {
  readonly items = input.required<CodeListItem[]>();
  readonly group = input.required<FormRecord<FormControl<string | null>>>();

  private readonly selectedItemId = signal<number | null>(null);

  readonly activeItemId = computed(() => this.selectedItemId() ?? this.items()[0]?.id ?? null);
  readonly activeItemName = computed(() => this.items().find((s) => s.id === this.activeItemId())?.name ?? '');
  readonly activeControl = computed<FormControl<string | null>>(
    () => this.controlFor(this.activeItemId()) ?? new FormControl(null),
  );

  controlFor(itemId: number | null): FormControl<string | null> | null {
    if (itemId === null) return null;
    return (this.group().controls[String(itemId)] as FormControl<string | null> | undefined) ?? null;
  }

  onItemChange(event: MatChipListboxChange): void {
    if (event.value != null) this.selectedItemId.set(event.value as number);
  }
}
